<script>
  export let className;
</script>

<style>
  .error-eyes {
    height: 5rem;
    width: 5rem;
  }
</style>

<svg
  class={className}
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 48 48"
  width="48"
  height="48">
  <title>big eyes</title>
  <g class="nc-icon-wrapper">
    <path
      d="M24,46A22,22,0,1,1,46,24,22.025,22.025,0,0,1,24,46Z"
      fill="#ffd764" />
    <path d="M13,32a9,9,0,1,1,9-9A9.01,9.01,0,0,1,13,32Z" fill="#fff" />
    <path d="M35,32a9,9,0,1,1,9-9A9.01,9.01,0,0,1,35,32Z" fill="#fff" />
    <path d="M13,26a3,3,0,1,1,3-3A3,3,0,0,1,13,26Z" fill="#444" />
    <path d="M35,26a3,3,0,1,1,3-3A3,3,0,0,1,35,26Z" fill="#444" />
  </g>
</svg>
